import {
  ADD_PRODUCT,
  DECREASE_PRODUCT_QUANTITY,
  INCREASE_PRODUCT_QUANTITY,
  RETURN_QTY_AFTER_CART_DLT,
} from "./actionType";

export const addProduct = (productValue) => {
  return {
    type: ADD_PRODUCT,
    payload: productValue,
  };
};

export const decreaseProductQuantity = (productId) => {
  return {
    type: DECREASE_PRODUCT_QUANTITY,
    payload: productId,
  };
};

export const increaseProductQuantity = (productId) => {
  return {
    type: INCREASE_PRODUCT_QUANTITY,
    payload: productId,
  };
};

export const returnQtyAfterCartDlt = (productId, quantity) => {
  return {
    type: RETURN_QTY_AFTER_CART_DLT,
    payload: {
      productId,
      quantity,
    },
  };
};
